"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchBarContainerStyles = void 0;
var searchBarContainerStyles = {
    container: {
        background: 'linear-gradient(45.17deg, #FF4F6B 0%, #FF4C25 202.94%)',
        color: '#fff',
        textTransform: 'capitalize',
        width: '100%',
        marginLeft: 0,
        marginTop: 0,
        position: 'sticky',
        top: 0,
        zIndex: 5,
    },
    blackBar: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '24px',
        marginBottom: '4px',
        background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%);',
        textTransform: 'none',
    },
    blackBarText: {
        lineHeight: '36px',
        marginLeft: '12px',
        marginRight: '12px',
    },
    searchButton: {
        textTransform: 'none',
        backgroundColor: 'white',
        color: 'black',
        paddingLeft: '12px',
        paddingRight: '12px',
        '&:hover': {
            backgroundColor: 'white',
        },
        fontWeight: 'bold',
        fontSize: '16px',
    },
    marginLeftRight: {
        marginLeft: { xs: '1rem', md: '0' },
        marginRight: { xs: '1rem', md: '0' },
    },
    facets: {
        marginLeft: { xs: '1rem', md: '0' },
        marginRight: { xs: '1rem', md: '0' },
    },
};
exports.searchBarContainerStyles = searchBarContainerStyles;
